/* EP — Panier : « Vous n'avez rien oublié ? »
   Parfums aux notes les plus proches de ceux du panier, calculés par le moteur de recherche
   (assets/ep-finder.js + ep-finder-data.json) et affichés avec les mêmes cartes que la page
   « Notre équivalent de … ». Les suggestions changent selon les parfums présents dans le panier.
   Config injectée par layout/theme.liquid : window.EP_FINDER_CFG = { dataUrl, liveUrl, notesUrl }
   v2 (23 oct. 2026) : flèches recalculées quand le tiroir s'ouvre (la flèche « suivant »
   restait désactivée au premier affichage car le bloc était créé tiroir fermé). */
(() => {
  if (window.__epCartUpsell) return;
  window.__epCartUpsell = true;

  // Mobile : le champ code promo est replié derrière un lien
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-ep-promo-toggle]');
    if (!t) return;
    const w = t.closest('[data-ep-promo]');
    if (!w) return;
    const open = !w.classList.contains('is-open');
    w.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const input = w.querySelector('input[name="discount"]');
      if (input) setTimeout(() => input.focus(), 60);
    }
  });

  const MAX = 8;          // cartes max
  const MIN = 4;          // en dessous : on complète avec les best-sellers
  const SOURCES = 3;      // nb d'articles du panier pris en compte
  const EN = /^en/i.test(document.documentElement.lang || '');
  const T = EN
    ? { eyebrow: 'Picked for your cart', heading: 'Forgot something?', prev: 'Previous', next: 'Next', adding: 'Adding…', added: 'Added ✓', error: 'Unavailable' }
    : { eyebrow: 'Choisis selon votre panier', heading: "Vous n'avez rien oublié ?", prev: 'Précédent', next: 'Suivant', adding: 'Ajout…', added: 'Ajouté ✓', error: 'Indisponible' };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  let dbPromise = null;
  let lastKey = '';
  let lastList = null;
  let rendering = false;

  const getJSON = async (url) => {
    const r = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error(r.status);
    return r.json();
  };

  const getDB = () => {
    if (!dbPromise) {
      const E = window.EPFinder;
      const cfg = window.EP_FINDER_CFG;
      if (!E || !cfg) return Promise.reject(new Error('finder'));
      dbPromise = E.load(cfg);
      dbPromise.catch(() => {});
    }
    return dbPromise;
  };

  /* ——— sélection ——— */
  const buildList = async (cart) => {
    const E = window.EPFinder;
    const db = await getDB();
    const inCart = {};
    cart.items.forEach((i) => { inCart[i.handle] = 1; });
    const refs = [...new Set(cart.items.map((i) => i.handle))]
      .map((h) => db.byH[h])
      .filter((p) => p && p.f && Object.keys(p.f).length)
      .slice(0, SOURCES);
    const cartInsp = {};
    refs.forEach((p) => { if (p.i) cartInsp[p.i] = 1; });

    const out = [];
    const seen = {};
    const perInsp = {};
    const perVendor = {};
    const push = (p, strict) => {
      if (!p || out.length >= MAX || seen[p.h] || inCart[p.h] || p.x || !p.av || !p.id) return;
      if (strict) {
        if (p.i && (cartInsp[p.i] || perInsp[p.i])) return;   // pas un 2e « même parfum »
        if ((perVendor[p.v] || 0) >= 3) return;               // de la variété dans les marques
      }
      seen[p.h] = 1;
      if (p.i) perInsp[p.i] = 1;
      perVendor[p.v] = (perVendor[p.v] || 0) + 1;
      out.push(p);
    };

    const lists = refs.map((r) => E.similarTo(db.P, r, { exclude: inCart }).map((x) => x.p));
    // On alterne entre les articles du panier pour que chacun ait ses suggestions
    for (let i = 0; i < 40 && out.length < MAX; i++) lists.forEach((l) => push(l[i], true));
    for (let i = 0; i < 40 && out.length < MIN; i++) lists.forEach((l) => push(l[i], false));
    if (out.length < MIN) {
      db.P.filter((p) => p.pop).forEach((p) => push(p, true));
      db.P.forEach((p) => out.length < MIN && push(p, false));
    }
    return out;
  };

  /* ——— rendu ——— */
  const ARROW = (d) => `<svg viewBox="0 0 20 20" width="14" height="14" fill="none" aria-hidden="true"><path d="${d}" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  const frame = (inner, count) => `
    <section class="ep-upsell epf" data-ep-upsell aria-label="${T.heading}">
      <div class="ep-upsell__head">
        <div>
          <p class="ep-upsell__eyebrow">${T.eyebrow}</p>
          <p class="ep-upsell__heading">${T.heading}</p>
        </div>
        ${count > 1 ? `<div class="ep-upsell__nav" data-ep-nav>
            <button type="button" class="ep-upsell__arrow" data-ep-prev aria-label="${T.prev}">${ARROW('M12 4l-6 6 6 6')}</button>
            <button type="button" class="ep-upsell__arrow" data-ep-next aria-label="${T.next}">${ARROW('M8 4l6 6-6 6')}</button>
          </div>` : ''}
      </div>
      <div class="ep-upsell__track" data-ep-track>${inner}</div>
    </section>`;

  const blockHTML = (list) => frame(list.map((p) => `<div class="ep-upsell__slide">${window.EPFinder.card(p)}</div>`).join(''), list.length);
  const skeletonHTML = () => frame([0, 1].map(() => `<div class="ep-upsell__slide">${window.EPFinder.skeleton(1)}</div>`).join(''), 0);

  // Recalcule l'état des flèches du bloc affiché (appelé à chaque ouverture du tiroir)
  const refreshArrows = () => {
    const body = getBody();
    const el = body && body.querySelector('[data-ep-upsell]');
    if (el && el.__epUpdate) el.__epUpdate();
  };

  const bind = (el) => {
    if (!el) return;
    const track = el.querySelector('[data-ep-track]');
    const nav = el.querySelector('[data-ep-nav]');
    const prev = el.querySelector('[data-ep-prev]');
    const next = el.querySelector('[data-ep-next]');
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 10 : track.clientWidth);
    const update = () => {
      // Tiroir fermé (bloc pas encore mesurable) : on ne bloque pas la flèche « suivant »,
      // sinon elle reste désactivée au premier clic une fois le tiroir ouvert.
      if (!track.clientWidth) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = false;
        return;
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    el.__epUpdate = update;
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.addEventListener('scrollend', update, { passive: true });
    // Le tiroir s'ouvre / la largeur change : on remesure
    if ('ResizeObserver' in window) new ResizeObserver(() => requestAnimationFrame(update)).observe(track);
    // Filet de sécurité : remesure dès que le curseur approche des flèches
    if (nav) nav.addEventListener('pointerenter', update);
    update();
    requestAnimationFrame(update);

    // Ajout au panier : on prend la main sur le bouton du moteur (le panier est déjà ouvert,
    // on le met à jour sur place et on marque la ligne pour suivre les ventes du bloc)
    el.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-epf-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      const label = btn.innerHTML;
      const span = btn.querySelector('span') || btn;
      btn.disabled = true;
      span.textContent = T.adding;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.getAttribute('data-epf-add')), quantity: 1, properties: { _ep_upsell: 'panier' } }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const added = await res.json();
        if (!res.ok || added.status) throw new Error(added.description || 'add');
        span.textContent = T.added;
        btn.classList.add('is-done');
        const cart = await getJSON(`${root}cart.js`);
        cart.sections = added.sections;
        if (window.FoxTheme && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart, sources: 'ep-upsell' });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (err) {
        span.textContent = T.error;
        setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 1800);
      }
    });
  };

  const getBody = () => document.querySelector('cart-drawer [id^="CartDrawerBody-"]');

  const inject = (html, withBind) => {
    const body = getBody();
    if (!body) return;
    const old = body.querySelector('[data-ep-upsell]');
    if (old) old.remove();
    if (!html) return;
    const host = body.querySelector('[data-ep-upsell-slot]') || body.querySelector(':scope > div') || body;
    host.insertAdjacentHTML('beforeend', html);
    if (withBind) bind(host.querySelector('[data-ep-upsell]'));
  };

  const render = async () => {
    const body = getBody();
    if (!body || rendering || !window.EPFinder) return;
    rendering = true;
    try {
      const cart = await getJSON(`${root}cart.js`);
      if (!cart.item_count) {
        lastKey = '';
        lastList = null;
        inject(null);
        return;
      }
      const key = cart.items.map((i) => i.handle).sort().join(',');
      if (key === lastKey && lastList) {
        if (!body.querySelector('[data-ep-upsell]') && lastList.length) inject(blockHTML(lastList), true);
        else refreshArrows();
        return;
      }
      if (lastList) {
        const ids = {};
        cart.items.forEach((i) => { ids[i.handle] = 1; });
        const kept = lastList.filter((p) => !ids[p.h]);
        inject(kept.length ? blockHTML(kept) : skeletonHTML(), !!kept.length);
      } else {
        inject(skeletonHTML(), false);
      }
      const list = await buildList(cart);
      lastKey = key;
      lastList = list;
      inject(list.length ? blockHTML(list) : null, true);
    } catch (e) {
      inject(null); // le panier reste fonctionnel sans suggestions
    } finally {
      rendering = false;
      const b = getBody();
      if (b && !b.querySelector('[data-ep-upsell]') && lastList && lastList.length) inject(blockHTML(lastList), true);
    }
  };

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(render, 60);
  };

  const observe = () => {
    const body = getBody();
    if (!body || !window.EPFinder) return false;
    new MutationObserver(() => {
      if (!body.querySelector('[data-ep-upsell]')) schedule();
    }).observe(body, { childList: true });
    const drawer = body.closest('cart-drawer');
    if (drawer) {
      new MutationObserver(() => {
        schedule();
        // remesure après l'animation d'ouverture du tiroir
        refreshArrows();
        setTimeout(refreshArrows, 350);
      }).observe(drawer, { attributes: true, attributeFilter: ['open', 'hidden', 'active'] });
    }
    document.addEventListener('cart:updated', schedule);
    schedule();
    // Préchargement discret de la base olfactive si le panier contient déjà quelque chose
    if (document.documentElement.classList.contains('cart-has-items')) {
      const warm = () => getDB().catch(() => {});
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
      else setTimeout(warm, 2500);
    }
    return true;
  };

  let tries = 0;
  const start = () => {
    if (!observe() && tries++ < 25) setTimeout(start, 400);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
